function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// @ts-nocheck
import toPath from 'lodash-es/toPath';
import Ajv from 'unitx/ajv';
import { isObject, mergeObjects, deepEquals, getDefaultFormState } from "./utils";
let formerCustomFormats = null;
let formerMetaSchema = null; // import WebWorker from '@utils/WebWorker'
// import AjvWorker from './AjvWebWorker/AjvWebWorker.worker'
// export function createAjvInstance(schema: any, onReady = () => {}) {
//   const ajv = new Ajv()
//   const ajvWebWorker = WebWorker(new AjvWorker())
//   ajvWebWorker.postMessage({
//     schema,
//   })
//   ajvWebWorker.onMessage(
//     ({data: { errors, isValid, isInitialized }}) => {
//       if (isInitialized) {
//         onReady()
//       }
//     },
//   )
//   ajv.validate = (data: any) => new Promise((res, rej) => {
//     ajvWebWorker.onMessage(
//       ({data: { errors, isValid, isInitialized }}) => {
//         if (!isInitialized) {
//           ajv.errors = errors
//           if (!isValid) {
//             rej(Error(errors))
//           }
//           res()
//         }
//       },
//     )
//     ajvWebWorker.postMessage({
//       data,
//     })
//   })
//   return ajv
// }

export const createAjvInstance = () => {
  const ajv = new Ajv({
    errorDataPath: 'property',
    allErrors: true,
    multipleOfPrecision: 8,
    schemaId: 'auto',
    unknownFormats: 'ignore' // jsonPointers: 'dataPath',

  }); // add custom formats

  ajv.addFormat('data-url', /^data:([a-z]+\/[a-z0-9-+.]+)?;(?:name=(.*);)?base64,(.*)$/);
  ajv.addFormat('color', /^(#?([0-9A-Fa-f]{3}){1,2}\b|aqua|black|blue|fuchsia|gray|green|lime|maroon|navy|olive|orange|purple|red|silver|teal|white|yellow|(rgb\(\s*\b([0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5])\b\s*,\s*\b([0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5])\b\s*,\s*\b([0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5])\b\s*\))|(rgb\(\s*(\d?\d%|100%)+\s*,\s*(\d?\d%|100%)+\s*,\s*(\d?\d%|100%)+\s*\)))$/);
  return ajv;
};
let ajv = createAjvInstance();

function toErrorSchema(errors) {
  if (!errors.length) {
    return {};
  }

  return errors.reduce((errorSchema, error) => {
    const {
      property,
      message
    } = error;
    const path = toPath(property);
    let parent = errorSchema; // If the property is at the root (.level1) then toPath creates
    // an empty array element at the first index. Remove it.

    if (path.length > 0 && path[0] === '') {
      path.splice(0, 1);
    }

    for (const segment of path.slice(0)) {
      if (!(segment in parent)) {
        parent[segment] = {};
      }

      parent = parent[segment];
    }

    if (Array.isArray(parent.__errors)) {
      // We store the list of errors for this node in a property named __errors
      // to avoid name collision with a possible sub schema field named
      // "errors" (see `validate.createErrorHandler`).
      parent.__errors = parent.__errors.concat(message);
    } else if (message) {
      parent.__errors = [message];
    }

    return errorSchema;
  }, {});
}

export function toErrorList(errorSchema, fieldName = 'root') {
  // XXX: We should transform fieldName as a full field path string.
  let errorList = [];

  if ('__errors' in errorSchema) {
    errorList = errorList.concat(errorSchema.__errors.map(stack => ({
      stack: `${fieldName}: ${stack}`,
      // @TODO:ADD: for validation error path
      dataPath: errorSchema.dataPath // @TODO:ADD_END

    })));
  }

  return Object.keys(errorSchema).reduce((acc, key) => {
    if (!['__errors', 'dataPath'].includes(key)) {
      acc = acc.concat(toErrorList(_objectSpread(_objectSpread({}, errorSchema[key]), {}, {
        // @TODO:ADD
        dataPath: errorSchema.dataPath ? `${errorSchema.dataPath}/${key}` : `/${key}` // @TODO:ADD_END

      }), key));
    }

    return acc;
  }, errorList);
}

function createErrorHandler(formData) {
  const handler = {
    // We store the list of errors for this node in a property named __errors
    // to avoid name collision with a possible sub schema field named
    // "errors" (see `utils.toErrorSchema`).
    __errors: [],

    addError(message) {
      this.__errors.push(message);
    }

  };

  if (isObject(formData)) {
    return Object.keys(formData).reduce((acc, key) => _objectSpread(_objectSpread({}, acc), {}, {
      [key]: createErrorHandler(formData[key])
    }), handler);
  }

  if (Array.isArray(formData)) {
    return formData.reduce((acc, value, key) => _objectSpread(_objectSpread({}, acc), {}, {
      [key]: createErrorHandler(value)
    }), handler);
  }

  return handler;
}

function unwrapErrorHandler(errorHandler) {
  return Object.keys(errorHandler).reduce((acc, key) => {
    if (key === 'addError') {
      return acc;
    }

    if (key === '__errors') {
      return _objectSpread(_objectSpread({}, acc), {}, {
        [key]: errorHandler[key]
      });
    }

    return _objectSpread(_objectSpread({}, acc), {}, {
      [key]: unwrapErrorHandler(errorHandler[key])
    });
  }, {});
}
/**
 * Transforming the error output from ajv to format used by jsonschema.
 * At some point, components should be updated to support ajv.
 */


function transformAjvErrors(errors = []) {
  if (errors === null) {
    return [];
  }

  return errors.map(e => {
    const {
      dataPath,
      keyword,
      message,
      params,
      schemaPath
    } = e;
    const property = `${dataPath}`; // put data in expected format

    return {
      name: keyword,
      property,
      message,
      params,
      // specific to ajv
      stack: `${property} ${message}`.trim(),
      schemaPath
    };
  });
}
/**
 * This function processes the formData with a user `validate` contributed
 * function, which receives the form data and an `errorHandler` object that
 * will be used to add custom validation errors for each field.
 */


export default (( // ajv,
formData, schema, customValidate, transformErrors, additionalMetaSchemas = [], customFormats = {}) => {
  // Include form data with undefined values, which is required for validation.
  const rootSchema = schema;
  formData = getDefaultFormState(schema, formData, rootSchema, true);
  const newMetaSchemas = !deepEquals(formerMetaSchema, additionalMetaSchemas);
  const newFormats = !deepEquals(formerCustomFormats, customFormats);

  if (newMetaSchemas || newFormats) {
    ajv = createAjvInstance();
  } // add more schemas to validate against


  if (additionalMetaSchemas && newMetaSchemas && Array.isArray(additionalMetaSchemas)) {
    ajv.addMetaSchema(additionalMetaSchemas);
    formerMetaSchema = additionalMetaSchemas;
  } // add more custom formats to validate against


  if (customFormats && newFormats && isObject(customFormats)) {
    Object.keys(customFormats).forEach(formatName => {
      ajv.addFormat(formatName, customFormats[formatName]);
    });
    formerCustomFormats = customFormats;
  }

  let validationError = null;

  try {
    ajv.validate(schema, formData);
  } catch (err) {
    validationError = err;
  }

  let errors = transformAjvErrors(ajv.errors); // Clear errors to prevent persistent errors, see #1104

  ajv.errors = null;
  const noProperMetaSchema = validationError && validationError.message && typeof validationError.message === 'string' && validationError.message.includes('no schema with key or ref ');

  if (noProperMetaSchema) {
    errors = [...errors, {
      stack: validationError.message
    }];
  }

  if (typeof transformErrors === 'function') {
    errors = transformErrors(errors);
  }

  let errorSchema = toErrorSchema(errors);

  if (noProperMetaSchema) {
    errorSchema = _objectSpread(_objectSpread({}, errorSchema), {
      $schema: {
        __errors: [validationError.message]
      }
    });
  }

  if (typeof customValidate !== 'function') {
    return {
      errors,
      errorSchema
    };
  }

  const errorHandler = customValidate(formData, createErrorHandler(formData));
  const userErrorSchema = unwrapErrorHandler(errorHandler);
  const newErrorSchema = mergeObjects(errorSchema, userErrorSchema, true); // XXX: The errors list produced is not fully compliant with the format
  // exposed by the jsonschema lib, which contains full field paths and other
  // properties.

  const newErrors = toErrorList(newErrorSchema);
  return {
    errors: newErrors,
    errorSchema: newErrorSchema
  };
});
/**
 * Validates data against a schema, returning true if the data is valid, or
 * false otherwise. If the schema is invalid, then this function will return
 * false.
 */

export function isValid(schema, data) {
  try {
    return ajv.validate(schema, data);
  } catch (e) {
    return false;
  }
}